import { createApp } from "vue";
import App from "@/App.vue";
import store from "@/store";
import router from "@/router";
import { createI18n } from "vue-i18n";
//Import translation file
import it from "@/locales/it.json";
import en from "@/locales/en.json";
import detectMobile from "@/plugins/mobile-detection";
import QrCode from "spid-wc-passwordless-infocert";

import "./version.js";

function getLang() {
  /// Retrieve cookie function
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  let param = params.get("lang");
  if (param) return param;
  else return "it";
}
const i18n = createI18n({
  legacy: false,
  messages: {
    it: it,
    en: en
  },
  locale: getLang(),
  fallbackLocale: "it"
});

const mountEl = document.querySelector("#app");
createApp(App, { ...mountEl.dataset })
  .use(store)
  .use(router)
  .use(i18n)
  .use(detectMobile)
  .use(QrCode)
  .mount("#app");
